// extracted by mini-css-extract-plugin
export default {"textWithHeader":"TextWithHeader_textWithHeader__cIB22"};